import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from 'containers';
import { PageLoader, NoData, Error } from 'components';

import { useStyles } from './style';

interface Props {
  templateLink: string | null;
  loading: boolean;
  error: boolean;
}

const ImportToolDetails: React.FC<Props> = ({
  templateLink,
  loading,
  error,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (error) {
    return <Error />;
  }

  if (loading) {
    return <PageLoader />;
  }

  if (!templateLink) {
    return <NoData />;
  }

  return (
    <>
      <PageTitle />
      <div>
        <p className={classes.description}>
          {t('#portal.import.template.description.message')}
        </p>
        <a className={classes.button} href={templateLink} download="download">
          {t('#portal.import.template.button.download')}
        </a>
      </div>
    </>
  );
};

export default memo(ImportToolDetails);
